import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { BaseEntity } from "yt-ng-framework";

export class DeoZaResenjeZaGoView extends BaseEntity{
    constructor(){
        super();
    }

    OdDatuma:NgbDate = null;
    DoDatuma:NgbDate = null;
    Dana:number = null;
    RbrDela:number = null;
    DatumPocetkaRada:NgbDate = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.OdDatuma = input.OdDatuma;
        this.DoDatuma = input.DoDatuma;
        this.Dana = input.Dana;
        this.RbrDela = input.RbrDela;
        this.DatumPocetkaRada = input.DatumPocetkaRada;      
        return this;
    }

    Serialize(input:DeoZaResenjeZaGoView){
        return input;
    }
}